import React from 'react';
import { View, StyleSheet, StyleProp, ViewStyle } from 'react-native';
import { COLORS } from './constants';
import { useRef } from 'react';
import { MB_SVG_TriangleRound } from '@mightybyte/rnw.components.svg-components';

enum TOOLTIP_POSITION {
    bottom,
    left,
    right,
    top,
}

enum TOOLTIP_ARROW_DIRECTION {
    left = 'left',
    right = 'right',
    up = 'up',
    down = 'down',
}

interface IMB_ToolTipWrapper {
    /**
     * The style of the wrapper.
     */
    containerStyle?: StyleProp<ViewStyle>,

    /**
     * The children components.
     */
    children: React.ReactNode,

    /**
     * The style of the arrow.
     */
    arrowStyle?: StyleProp<ViewStyle>,

    /**
     * The color of the arrow.
     * 
     * Default: "#ffffff" (white)
     */
    arrowColor?: string,

    /**
     * The size of the arrow.
     * 
     * Default: 21
     */
    arrowSize?: number,

    /**
     * The direction of the arrow.
     * 
     * Default: TOOLTIP_ARROW_DIRECTION.down
     */
    arrowDirection?: TOOLTIP_ARROW_DIRECTION,
}



const arrowRotationDegrees = {
    [TOOLTIP_ARROW_DIRECTION.up]: '0deg',
    [TOOLTIP_ARROW_DIRECTION.right]: '90deg',
    [TOOLTIP_ARROW_DIRECTION.left]: '-90deg',
    [TOOLTIP_ARROW_DIRECTION.down]: '180deg',
};

const MB_ToolTipWrapper = ({
    containerStyle,
    children,
    arrowStyle,
    arrowColor = COLORS.white,
    arrowSize = 21,
    arrowDirection = TOOLTIP_ARROW_DIRECTION.down
}: IMB_ToolTipWrapper) => {
    const toolTipRef = useRef<View | null>(null);

    const arrowPosition = (): StyleProp<ViewStyle> => {
        if (arrowDirection === TOOLTIP_ARROW_DIRECTION.down) {
            return { bottom: -10, left: 15 };
        }
        else if (arrowDirection === TOOLTIP_ARROW_DIRECTION.left) {
            return { left: -16, top: '45%' };
        }
        else if (arrowDirection === TOOLTIP_ARROW_DIRECTION.right) {
            return { right: -14, top: '45%' };
        } else if (arrowDirection === TOOLTIP_ARROW_DIRECTION.up) {
            return { top: -10, left: 15 };
        }
    };

    return (
        <View style={[styles.container, containerStyle]} ref={toolTipRef}>
            <MB_SVG_TriangleRound
                color={arrowColor}
                size={arrowSize}
                containerStyle={[
                    {
                        position: 'absolute',
                        transform: [{ rotate: arrowRotationDegrees[arrowDirection] }]
                    },
                    arrowPosition(),
                    arrowStyle,
                ]}
            />
            {children}
        </View>
    );
};

export { MB_ToolTipWrapper, TOOLTIP_POSITION, TOOLTIP_ARROW_DIRECTION };

const styles = StyleSheet.create({
    container: {
        borderRadius: 8,
        backgroundColor: 'white',
    },
});
